ACC.repairProducts = {
  productTypeDropDown: '#producttype',
  leftNavigation: '.ph-leftnav-myaccount',
  nonSerializedStep: '.ph-non_serialized_prod',
  serializedStep: '.ph-serialized_prod',
  prodtypeMaskId: '#prodtype_MASK',
  prodtypeCpapId: '#prodtype_CPAP',
  prodtypeRddId: '#prodtype_RDD',
  productTypeRdd: 'Respiratory Drug Delivery',
  formFieldErrorClass: 'ph-form_field_error',
  errorSpanClass: '.ph-signup__error',
  errorMsgSpan: 'ph-repairs__emptyvalue',
  disabledbuttonClass: 'ph-disabledbutton',
  hashShippingInfo: 'shippinginfo',
  prodInfostartButton: '.ph-productinfo_startbtn',
  repairHistoryContainer: 'ph-repairshistory_wrapper',
  fromPageString: 'fromPage',
  selectedAddrString: 'selectedAddress',
  repairProductsContainer: 'ph-repairs_product_container',
  hiddenClass: 'hidden',
  poNumber: 'poNumber',
  serialNumberInput: 'serialNumbers',
  serialNumberErrorMsg: 'ph-repairs__title_error_msg',
  serialNumberErrorBlock: 'ph-repairs__title_error',
  nonSerialNumberErrorMsg: 'ph-repairs__partno_error_msg',
  nonSerialErrorBlock: 'ph-repairs__partno_error',
  productTypeCpap: 'CPAP / BiPAP',
  repairsProductList: 'ph-repairs_productlist',
  partNumberMaskInput: 'partNumber_MASK',
  partNumberRddInput: 'partNumber_RDD',
  rddCheckButton: 'ph-rdd_check',
  maskCheckButton: 'ph-mask_check',
  commonErrorMessage: 'ph-invalidslno_errormessage',
  isSerializedType: 'ph-isSerialized_product',
  nonSerialStartBtn: 'ph-issueinfo_nonserial_startbtn',
  serialStartBtn: 'ph-issueinfo_serial_startbtn',
  listItemTemplate: 'repairsListItemTemplate',
  listItemFinalTemplate: 'repairsListItemFinalTemplate',
  lotNumberInput: 'lotNumber',
  orderNumberInput: 'orderNumber',
  reviewActiveProdWrapper: 'ph-reviewpage-activewarranty',
  reviewActiveProductContainer: 'ph-reviewpage-active-products',
  reviewOutProdWrapper: 'ph-reviewpage-outofwarranty',
  reviewOutProductContainer: 'ph-reviewpage-outof-products',
  phSendingforRepair: 'ph-sendingfor_repair',
  phSerialMsgBanner: 'ph-serial_msg_banner',
  phNonserialMsgBanner: 'ph-nonserial_msg_banner',
  warrantyInfosDetailedList: '',
  productInfosDetailedList: [],
  warrantyDuplicationHybrisList: '',
  activeWarrantyProducts: '',
  outofWarrantyProducts: '',
  notServicableProducts: '',
  serializedBreadCrumbMobile: [],
  prodDesc: 'data-proddesc',
  reviewfinal: 'reviewfinal',
  displayNone: 'ph-d-none',
  enableNewRepairField: $('.enableNewRepairField').text(),
  serializedBreadCrumb: [
    {
      index: 'L',
      disabled: '',
      url: '#productinfo',
      selected: 'ph-navitem_selected',
      label: $('.ph-serialized_prod [data-index="1"]').text().trim() || 'Product info'
    },
    {
      index: 2,
      disabled: '',
      url: '#issues',
      selected: '',
      label: $('.ph-serialized_prod [data-index="2"]').text().trim() || 'Issues'
    },
    {
      index: 3,
      disabled: '',
      url: '#warranty',
      selected: '',
      label: $('.ph-serialized_prod [data-index="3"]').text().trim() || 'Warranty'
    },
    {
      index: 4,
      disabled: '',
      url: '#reviewandsubmit',
      selected: '',
      label: $('.ph-serialized_prod [data-index="4"]').text().trim() || 'Review & Submit'
    }
  ],
  bindAll: function() {
    $('.ph-repairs_questionare').change(function() {
      var isMandatory = '';

      ACC.repairProductsAjax.landingPageOmniturTagging($(this));

      if ($(this).val() === 'YES') {
        $('.ph-repairreq_button').addClass(ACC.repairProducts.disabledbuttonClass);
        $.colorbox({
          inline: true,
          href: '#ph-patientHarmWarning',
          maxWidth: '522px',
          width: '100%',
          height: '100%',
          maxHeight: '380px',
          scrolling: true,
          overlayClose: false,
          escKey: true,
          onClosed: function() {
            $.colorbox.close();
          }
        });
      } else {
        isMandatory = ACC.repairProducts.validateRadioButtonSelected();
        ACC.repairProducts.setQuestionaireForUser($(this));

        if (isMandatory === 'true' && $('.ph-asmUserFlag').html() === 'false') {
          $('.ph-repairs_startbtn').removeClass(ACC.repairProducts.disabledbuttonClass);
        }
      }
    });
    $('.ph-repairs_popup_okbtn').click(function() {
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'button:repair_request:ok');
      $.colorbox.close();
    });
    $('.ph-repairreq_startbtn').click(function() {
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'button:repair_request:start_now');
      localStorage.setItem(ACC.repairProducts.fromPageString, ACC.repairProducts.hashShippingInfo);
      $('.' + ACC.repairProducts.repairHistoryContainer).addClass(ACC.repairProducts.hiddenClass);
      $(ACC.repairProducts.leftNavigation).addClass(ACC.repairProducts.hiddenClass);
      ACC.repairProducts.isAddressSelected();
      location.hash = ACC.repairProducts.hashShippingInfo;
    });
    $('.ph-repairreq__cancel_button').click(function() {
      $(ACC.repairProducts.leftNavigation).show();
      ACC.repairProductsAjax.omnitureTaggingforCancelBtn($(this).attr('data-btnname'));
      ACC.repairProducts.clearAllFlags();
      location.href = escape(location.pathname);
    });

    $('.ph-btnstartrequest').click(function() {
      ACC.repairProductsAjax.populateProductTypeDropdown();
      $(ACC.repairProducts.leftNavigation).hide();
      location.hash = 'productinfo';
    });
    $(ACC.repairProducts.productTypeDropDown).on('change', function() {
      var productType = $(this).val(),
          isSerializedProduct = $(this).find(':selected').attr('data-isserialized');

      ACC.repairProducts.clearFormFeilds();
      ACC.repairProducts.resetBreadCrumbs();
      ACC.repairProductsAjax.productTypeOmnitureTagging(productType);
      $('.' + ACC.repairProducts.isSerializedType).val(isSerializedProduct);

      if (productType.length > 0) {
        ACC.repairProducts.showInputFormElements(isSerializedProduct, productType);
      }
    });
    $('#' + ACC.repairProducts.serialNumberInput).on('blur', function() {
      if ($(this).val() === '') {
        ACC.repairProducts.setErrorFlag($(this), true);
      } else if ($(this).val().length > 0) {
        ACC.repairProducts.validateSerialNumberInput();
        ACC.repairProducts.clearErrorFlag($(this), true);
      } else {
        ACC.repairProducts.clearErrorFlag($(this), true);
      }
    });
    $('.ph-cpap_submitsearch').on('click', function() {
      var canSubmit = '';

      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'create_repair_request:product_info:button:search');
      $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      canSubmit = ACC.repairProducts.validateSerialNumberInput();

      if (!canSubmit) {
        ACC.repairProductsAjax.getProductInfoDetails();
      }
    });
    $('.' + ACC.repairProducts.maskCheckButton).on('click', function() {
      var materialNumber = $('#' + ACC.repairProducts.partNumberMaskInput).val();

      $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      ACC.repairProductsAjax.getMaterialSearchInfoDetails(materialNumber);
    });
    $('.' + ACC.repairProducts.rddCheckButton).on('click', function() {
      var materialNumber = $('#' + ACC.repairProducts.partNumberRddInput).val();

      $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      ACC.repairProductsAjax.getMaterialSearchInfoDetails(materialNumber);
    });
    $('#' + ACC.repairProducts.partNumberRddInput).on('blur', function() {
      var errorFlag = '';

      errorFlag = ACC.repairProducts.validatePartNumber($(this));

      if (errorFlag) {
        $('.' + ACC.repairProducts.rddCheckButton).addClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        ACC.repairProducts.validateLotAndOrderNumber();
      }
    });
    $('#' + ACC.repairProducts.partNumberMaskInput).on('blur', function() {
      var errorFlag = '';

      errorFlag = ACC.repairProducts.validatePartNumber($(this));

      if (errorFlag) {
        $('.' + ACC.repairProducts.maskCheckButton).addClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        ACC.repairProducts.validateLotAndOrderNumber();
      }

      ACC.repairProducts.maskFieldsValidation();
    });
    $(ACC.repairProducts.prodInfostartButton).click(function() {
      var productType = $(ACC.repairProducts.productType).val();

      if (productType === '') {
        ACC.repairProducts.validateInputFields($(ACC.repairProducts.productType));
      }

      ACC.repairProducts.resetReviewDom();
      ACC.repairProducts.resetWarrantyDom();
      location.hash = 'issues';
      ACC.repairProductsAjax.populateUniqueKeyCreation();
      ACC.repairProducts.loadRepaiIssuesInfo();
      $('.' + ACC.repairProducts.nonSerialStartBtn).addClass(ACC.repairProducts.disabledbuttonClass);
      $('.' + ACC.repairProducts.serialStartBtn).addClass(ACC.repairProducts.disabledbuttonClass);
    });
    $('.ph-repairspage_infomark__icon').on('click', function() {
      var $parent = $(this).closest('.ph-serialnumber-label'),
          tooltipText = '.ph-cartpage_product_details__tooltip_text';

      $parent.find(tooltipText).toggleClass(ACC.repairProducts.hiddenClass);
      $parent.siblings().find(tooltipText).addClass(ACC.repairProducts.hiddenClass);
    });
    $(document).on('change', '.ph-product_checkbox', function() {
      var selectedSerialNumber = '',
          dataAttribute = 'data-serialnumber';

      if ($(this).prop('checked') === true) {
        selectedSerialNumber = $(this).attr(dataAttribute);
        ACC.repairProducts.checkForDuplicateServiceNotification(selectedSerialNumber);
        ACC.repairProducts.addSelectedProductForRepairs(selectedSerialNumber, true);
        ACC.repairProductsAjax.selectProductOmnitureTagging($(this).attr(ACC.repairProducts.prodDesc), true);
      } else {
        ACC.repairProducts.removeItemForRepairs($(this).attr(dataAttribute), true);
        ACC.repairProductsAjax.selectProductOmnitureTagging($(this).attr(ACC.repairProducts.prodDesc), false);
        selectedSerialNumber = $(this).attr(dataAttribute);
        $('.ph-duplicate-' + selectedSerialNumber).hide();
      }

      if ($('.ph-product_checkbox:checked').length > 0) {
        $(ACC.repairProducts.prodInfostartButton).removeClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      }
    });
    $(document).on('change', '.ph-material_checkbox', function() {
      var selectedMaterialNumber = '',
          dataAttribute = 'data-materialno',
          lotNumber = $('#' + ACC.repairProducts.lotNumberInput).val(),
          orderNumber = $('#' + ACC.repairProducts.orderNumberInput).val();

      if ($(this).prop('checked') === true) {
        selectedMaterialNumber = $(this).attr(dataAttribute);
        ACC.repairProducts.addSelectedProductForRepairs(selectedMaterialNumber, false);
        ACC.repairProductsAjax.selectProductOmnitureTagging($(this).attr(ACC.repairProducts.prodDesc), true);
      } else {
        ACC.repairProducts.removeItemForRepairs($(this).attr(dataAttribute), false);
        ACC.repairProductsAjax.selectProductOmnitureTagging($(this).attr(ACC.repairProducts.prodDesc), false);
      }

      if ($('.ph-material_checkbox:checked').length > 0 && (lotNumber.length > 0 || orderNumber.length > 0)) {
        $(ACC.repairProducts.prodInfostartButton).removeClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      }

      ACC.repairProducts.maskFieldsValidation();
    });
    $('#lotNumber, #orderNumber').on('blur', function() {
      var inputValueStr = $(this).val();

      ACC.repairProducts.setOrderNumberToArray($(this));
      ACC.repairProducts.validatePartNumberCheckBtn();

      if ($.trim(inputValueStr).length === 0) {
        ACC.repairProducts.validateLotAndOrderNumber();
      }

      if ($('.ph-material_checkbox:checked').length > 0 && $(this).val().length > 0) {
        $(ACC.repairProducts.prodInfostartButton).removeClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
      }

      ACC.repairProducts.maskFieldsValidation();
    });
    $('#poNumber').on('blur', function() {
      var poNumber = $(this).val();

      $('.ph-ponumber-tooltiptext').hide();

      if (poNumber) {
        localStorage.setItem(ACC.repairProducts.poNumber, poNumber);
      }
    });
    $('.ph-repairs_link').click(function() {
      ACC.repairProducts.clearAllFlags();
    });
    $('.ph-repairslink_sidebar').click(function() {
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'button:repair_request:sidebar:repair');
    });
  },
  maskFieldsValidation: function() {
    var productTypeItem = $(ACC.repairProducts.productTypeDropDown).val();

    if (productTypeItem === 'Mask' && ACC.repairProducts.enableNewRepairField === 'true') {
      ACC.repairProducts.maskFieldsValidationTask();
    }
  },
  maskFieldsValidationTask: function() {
    var isValid = false,
        lotNumberValue = $('#lotNumber2').val(),
        orderNumberValue = $('#orderNumber').val(),
        maskPartNumberValue = $('#' + ACC.repairProducts.partNumberMaskInput).val();

    if ($.trim(lotNumberValue).length > 0 &&
        $.trim(orderNumberValue).length > 0 &&
        $.trim(maskPartNumberValue).length > 0) {
      isValid = true;
    }


    if (isValid) {
      $('.' + ACC.repairProducts.maskCheckButton).removeClass(ACC.repairProducts.disabledbuttonClass);
    } else {
      $('.' + ACC.repairProducts.maskCheckButton).addClass(ACC.repairProducts.disabledbuttonClass);
    }

    if (isValid && $('.ph-material_checkbox:checked').length > 0) {
      $(ACC.repairProducts.prodInfostartButton).removeClass(ACC.repairProducts.disabledbuttonClass);
      ACC.repairProducts.productInfosDetailedList[0].lotNumber = lotNumberValue;
    } else {
      $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
    }
  },
  disableCheckBtn: function(inputValue, btnClassName) {
    if ($.trim(inputValue).length === 0) {
      $('.' + btnClassName).addClass(ACC.repairProducts.disabledbuttonClass);
    } else {
      $('.' + btnClassName).removeClass(ACC.repairProducts.disabledbuttonClass);
    }
  },
  validateLotAndOrderNumber: function() {
    var lotNumberValue = $('#lotNumber').val(),
        productTypeItem = $(ACC.repairProducts.productTypeDropDown).val(),
        orderNumberValue = $('#orderNumber').val();

    if (productTypeItem === ACC.repairProducts.productTypeRdd) {
      ACC.repairProducts.disableCheckBtn(lotNumberValue, ACC.repairProducts.rddCheckButton);
    }

    if (productTypeItem !== ACC.repairProducts.productTypeRdd) {
      ACC.repairProducts.disableCheckBtn(orderNumberValue, ACC.repairProducts.maskCheckButton);
    }
  },
  validatePartNumberCheckBtn: function() {
    var partNumberRdd = $('#' + ACC.repairProducts.partNumberRddInput).val(),
        productTypeValue = $(ACC.repairProducts.productTypeDropDown).val(),
        partNumberMask = $('#' + ACC.repairProducts.partNumberMaskInput).val();

    if (productTypeValue === ACC.repairProducts.productTypeRdd) {
      ACC.repairProducts.disableCheckBtn(partNumberRdd, ACC.repairProducts.rddCheckButton);
    } else {
      ACC.repairProducts.disableCheckBtn(partNumberMask, ACC.repairProducts.maskCheckButton);
    }
  },
  resetWarrantyDom: function() {
    $('.ph-outofwarranty-products').html('');
    $('.ph-repairs-outofwarranty').hide();
    $('.ph-activewarranty-products').html('');
    $('.ph-repairs-activewarranty').hide();
    $('.ph-nonservicable-products').html('');
    $('.ph-repairs-nonservicable').hide();
  },
  resetReviewDom: function() {
    $('.' + ACC.repairProducts.reviewActiveProductContainer).html('');
    $('.' + ACC.repairProducts.reviewActiveProdWrapper).hide();
    $('.' + ACC.repairProducts.reviewOutProductContainer).html('');
    $('.' + ACC.repairProducts.reviewOutProdWrapper).hide();
  },
  setQuestionaireForUser: function($element) {
    if ($element.attr('name') === 'repairPatientHarm') {
      localStorage.setItem('repairPatientHarm', $element.val());
    } else {
      localStorage.setItem('repairthermalEvent', $element.val());
    }
  },
  setOrderNumberToArray: function($elementId) {
    if ($elementId.attr('name') === ACC.repairProducts.orderNumberInput && ACC.repairProducts.productInfosDetailedList.length > 0) {
      ACC.repairProducts.productInfosDetailedList[0].orderNumber = $elementId.val();
    }

    if ($elementId.attr('name') === ACC.repairProducts.lotNumberInput && ACC.repairProducts.productInfosDetailedList.length > 0) {
      ACC.repairProducts.productInfosDetailedList[0].lotNumber = $elementId.val();
    }
  },
  checkForDuplicateServiceNotification: function(prodSerialNumber) {
    var duplicate = '';

    if (ACC.repairProducts.warrantyDuplicationHybrisList.length > 0) {
      duplicate = ACC.repairProducts.warrantyDuplicationHybrisList.filter(function(item) {
        return item.repairCompositeKey === prodSerialNumber;
      });
    }

    if (duplicate.length > 0) {
      $('.ph-duplicate-' + prodSerialNumber).show();
    }
  },
  addSelectedProductForRepairs: function(prodSerialNumber, isSerialSearch) {
    var selectedProduct = '',
        filteredItem = '';

    if (ACC.repairProducts.warrantyInfosDetailedList.length > 0) {
      selectedProduct = ACC.repairProducts.warrantyInfosDetailedList.filter(function(item) {
        if (isSerialSearch) {
          filteredItem = item.repairCompositeKey === prodSerialNumber;
        } else {
          filteredItem = item.materialNumber === prodSerialNumber;
        }

        return filteredItem;
      });

      if ($(ACC.repairProducts.productTypeDropDown).val() === ACC.repairProducts.productTypeRdd) {
        selectedProduct[0].partNumber = $('#' + ACC.repairProducts.partNumberRddInput).val();
      } else {
        selectedProduct[0].partNumber = $('#' + ACC.repairProducts.partNumberMaskInput).val();
      }

      if (selectedProduct[0].equipmentDescription) {
        selectedProduct[0].materialText = selectedProduct[0].equipmentDescription;
      }

      selectedProduct[0].lotNumber = $('#' + ACC.repairProducts.lotNumberInput).val();
      selectedProduct[0].orderNumber = $('#' + ACC.repairProducts.orderNumberInput).val();
      selectedProduct[0].productType = $(ACC.repairProducts.productTypeDropDown).val();
      selectedProduct[0].shipToAddress = localStorage.getItem(ACC.repairProducts.selectedAddrString);
      selectedProduct[0].patientHarmAssociated = localStorage.getItem('repairPatientHarm');
      selectedProduct[0].termalEventAssociated = localStorage.getItem('repairthermalEvent');

      if (localStorage.getItem(ACC.repairProducts.poNumber)) {
        selectedProduct[0].poNumber = localStorage.getItem(ACC.repairProducts.poNumber);
      }

      if ($(ACC.repairProducts.productTypeDropDown).val() === 'Mask') {
        selectedProduct[0].lotNumber = $('#lotNumber2').val();
      }

      ACC.repairProducts.productInfosDetailedList = ACC.repairProducts.productInfosDetailedList.concat(selectedProduct);

      ACC.repairProducts.sortingCondition(isSerialSearch);
    }
  },
  sortingCondition: function(isSerialSearch) {
    if (isSerialSearch) {
      ACC.repairProducts.productInfosDetailedList.sort(ACC.repairProducts.sortproductInfosDetailedList('serialNumber'));
    } else {
      ACC.repairProducts.productInfosDetailedList.sort(ACC.repairProducts.sortproductInfosDetailedList('materialNumber'));
    }
  },
  sortproductInfosDetailedList: function(prop) {
    var sortOrder = 1,
        sortProp = prop;

    if (sortProp[0] === '-') {
      sortOrder = -1;
      sortProp = sortProp.substr(1);
    }

    return function(sc, tg) {
      var result = 0,
          tgresult = 0;

      if (sc[sortProp] < tg[sortProp]) {
        result = -1;
      } else {
        if (sc[sortProp] > tg[sortProp]) {
          tgresult = 1;
        }

        result = tgresult;
      }

      return result * sortOrder;
    };
  },

  removeItemForRepairs: function(prodSerialNumber, isSerialSearch) {
    var filteredItem = '';

    if (ACC.repairProducts.productInfosDetailedList.length > 0) {
      ACC.repairProducts.productInfosDetailedList = ACC.repairProducts.productInfosDetailedList.filter(function(item) {
        if (isSerialSearch) {
          filteredItem = item.repairCompositeKey !== prodSerialNumber;
        } else {
          filteredItem = item.materialNumber !== prodSerialNumber;
        }

        return filteredItem;
      });
    }
  },
  validateRadioButtonSelected: function() {
    var $patientHarm = $('input[name="repairPatientHarm"]:checked'),
        $thermalEvent = $('input[name="repairthermalEvent"]:checked'),
        isMandatory = 'false';

    if ($patientHarm.length > 0 && $thermalEvent.length > 0) {
      if ($patientHarm.val() !== 'YES' && $thermalEvent.val() !== 'YES') {
        isMandatory = 'true';
      }
    }

    return isMandatory;
  },
  resetBreadCrumbs: function() {
    var length = ACC.repairProducts.serializedBreadCrumb.length;

    for (var i = 0; i < length; i = i + 1) {
      if (i > 0) {
        ACC.repairProducts.serializedBreadCrumb[i].disabled = 'ph-disabled';
        ACC.repairProducts.serializedBreadCrumb[i].selected = '';
        ACC.repairProducts.serializedBreadCrumb[i].index = i + 1;
      }
    }
  },
  setBreadCrumbForProductType: function() {
    var arrayLength = '',
        breadCrumbs = '';

    if ($('.' + ACC.repairProducts.isSerializedType).val() === 'false') {
      breadCrumbs = ACC.repairProducts.serializedBreadCrumb.filter(function(item) {
        return item.url !== '#warranty';
      });
      arrayLength = breadCrumbs.length;
      breadCrumbs[arrayLength - 1].index = 3;
    } else {
      breadCrumbs = ACC.repairProducts.serializedBreadCrumb.filter(function(item) {
        return item.label !== '';
      });
    }

    return breadCrumbs;
  },
  loadBreadCrumbs: function(containerClass, breadCrumbsArray, scriptID) {
    $('.' + containerClass).html($('#' + scriptID).tmpl({
      breadCrumbs: breadCrumbsArray
    }));
  },
  loadRepaiIssuesInfo: function() {
    var breadCrumbsArray = ACC.repairProducts.setBreadCrumbForProductType();

    ACC.repairProducts.loadBreadCrumbsForProducttype(1, breadCrumbsArray, 'ph-breadCrumbs_issuepage');

    if ($('.' + ACC.repairProducts.isSerializedType).val() === 'true') {
      $('.' + ACC.repairProducts.nonSerialStartBtn).hide();
      $('.' + ACC.repairProducts.serialStartBtn).show();
    } else {
      $('.' + ACC.repairProducts.nonSerialStartBtn).show();
      $('.' + ACC.repairProducts.serialStartBtn).hide();
    }

    if (ACC.repairProducts.productInfosDetailedList.length > 0) {
      $('#ph-repairs-issue').html($('#repairsIssueTemplate').tmpl({
        issueProducts: ACC.repairProducts.productInfosDetailedList,
        enableNewRepairField: ACC.repairProducts.enableNewRepairField
      }));
      ACC.repairProducts.productInfosDetailedList.forEach(function(item) {
        item.queUnitAlarm = false;
        item.quePatientOnUnit = false;
        item.queOutOfBoxFailure = false;
        item.queAvailableToReturn = false;
        item.repairIssueDescription = '';

        if (item.isMaterialService === 'Y') {
          item.sendingForRepair = true;
        } else {
          item.sendingForRepair = false;
        }
      });

      $('.repairIssueOptionalm').on('change', function() {
        ACC.repairProducts.enableIssueNextFlow($(this), 'queUnitAlarm');
      });

      $('.repairIssueOptionPt').on('change', function() {
        ACC.repairProducts.enableIssueNextFlow($(this), 'quePatientOnUnit');
      });

      $('.repairIssueOptionOb').on('change', function() {
        ACC.repairProducts.enableIssueNextFlow($(this), 'queOutOfBoxFailure');
      });
      $('.repairIssueOptionPar').on('change', function() {
        ACC.repairProducts.enableIssueNextFlow($(this), 'queAvailableToReturn');
      });

      $('textarea').keyup($.debounce(700, false, function() {
        ACC.repairProducts.enableIssueNextFlow($(this), 'repairIssueDescription');
      }));
    }

    $('.' + ACC.repairProducts.serialStartBtn).click(function() {
      location.hash = 'warranty';
      ACC.repairProducts.loadWarrantyInfo();
    });
    $('.' + ACC.repairProducts.nonSerialStartBtn).click(function() {
      location.hash = 'reviewandsubmit';
      ACC.repairProducts.loadReviewnSubmitInfo();
    });
  },

  enableIssueNextFlow: function(issueObj, selectAns) {
    var pindex = issueObj.closest('.ph-repairs-qna').index();

    if (pindex > 0) {
      pindex = (pindex / 2) - 1;
      pindex = pindex + 1;
    }

    ACC.repairProducts.productInfosDetailedList[pindex][selectAns] = $.trim(issueObj.val());

    var validIssue = {};

    ACC.repairProducts.productInfosDetailedList.forEach(function(item, k) {
      var alarm = ACC.repairProducts.productInfosDetailedList[k].queUnitAlarm,
          unit = ACC.repairProducts.productInfosDetailedList[k].quePatientOnUnit,
          outofbox = ACC.repairProducts.productInfosDetailedList[k].queOutOfBoxFailure,
          desc = ACC.repairProducts.productInfosDetailedList[k].repairIssueDescription,
          answers = [];

      if (ACC.repairProducts.enableNewRepairField === 'true') {
        answers.push(alarm, unit, outofbox, ACC.repairProducts.productInfosDetailedList[k].queAvailableToReturn, desc);
      } else {
        answers.push(alarm, unit, outofbox, desc);
      }

      if (answers.indexOf(false) === -1 && answers.indexOf('') === -1) {
        validIssue[k] = true;
      } else {
        validIssue[k] = false;
      }
    });

    if (Object.keys(validIssue).length === ACC.repairProducts.productInfosDetailedList.length) {
      var issueBtn = '';

      if ($('.' + ACC.repairProducts.nonSerialStartBtn + ':visible').length === 0) {
        issueBtn = ACC.repairProducts.serialStartBtn;
      } else {
        issueBtn = ACC.repairProducts.nonSerialStartBtn;
      }

      var values = Object.keys(validIssue).map(function(e) {
        return validIssue[e];
      });

      if (values.indexOf(false) === -1) {
        $('.' + issueBtn).removeClass(ACC.repairProducts.disabledbuttonClass);
      } else {
        $('.' + issueBtn).addClass(ACC.repairProducts.disabledbuttonClass);
      }
    }
  },

  filterWarrantyByType: function(key, type) {
    var prodList = '';

    prodList = ACC.repairProducts.productInfosDetailedList.filter(function(item) {
      return item[key] === type && item.isMaterialService !== 'N';
    });

    return prodList;
  },
  filterNonServicableProducts: function() {
    var servProdList = '';

    servProdList = ACC.repairProducts.productInfosDetailedList.filter(function(item) {
      return item.isMaterialService === 'N';
    });

    return servProdList;
  },
  populateWarrrantyInfo: function() {
    ACC.repairProducts.activeWarrantyProducts = ACC.repairProducts.filterWarrantyByType('warrantyStatus', 'G');
    ACC.repairProducts.outofWarrantyProducts = ACC.repairProducts.filterWarrantyByType('warrantyStatus', 'R');
    ACC.repairProducts.notServicableProducts = ACC.repairProducts.filterNonServicableProducts();

    if (ACC.repairProducts.activeWarrantyProducts.length > 0) {
      $('.ph-activewarranty-products').html($('#' + ACC.repairProducts.listItemTemplate).tmpl({
        listItem: ACC.repairProducts.activeWarrantyProducts
      }));

      $('.ph-repairs-activewarranty').show();
    }

    if (ACC.repairProducts.outofWarrantyProducts.length > 0) {
      $('.ph-outofwarranty-products').html($('#' + ACC.repairProducts.listItemTemplate).tmpl({
        listItem: ACC.repairProducts.outofWarrantyProducts
      }));

      $('.ph-repairs-outofwarranty').show();
    }

    if (ACC.repairProducts.notServicableProducts.length > 0) {
      $('.ph-nonservicable-products').html($('#' + ACC.repairProducts.listItemTemplate).tmpl({
        listItem: ACC.repairProducts.notServicableProducts
      }));

      $('.ph-repairs-nonservicable').show();
    }

    if (ACC.repairProducts.notServicableProducts.length === ACC.repairProducts.productInfosDetailedList.length) {
      $('.ph-outofservice-btnwrapper').show();
      $('.ph-activewarranty-btnwrapper').hide();
    } else {
      $('.ph-outofservice-btnwrapper').hide();
      $('.ph-activewarranty-btnwrapper').show();
    }
  },
  loadBreadCrumbsForProducttype: function(step, breadCrumbsArray, containerClass) {
    for (var i = 0; i < step; i = i + 1) {
      breadCrumbsArray[i].selected = 'ph-navitem_selected';
      breadCrumbsArray[i].index = 'L';
      breadCrumbsArray[i].disabled = '';
    }

    ACC.repairProducts.serializedBreadCrumbMobile = [];

    for (var j = 0; j <= step; j = j + 1) {
      ACC.repairProducts.serializedBreadCrumbMobile.push(breadCrumbsArray[j]);
    }

    breadCrumbsArray[step].disabled = '';
    ACC.repairProducts.loadBreadCrumbs(containerClass, breadCrumbsArray, 'repairsBreadCrumb');
    ACC.repairProducts.loadBreadCrumbs(containerClass + '_mob', ACC.repairProducts.serializedBreadCrumbMobile, 'repairsBreadCrumbForMobile');
  },
  loadWarrantyInfo: function() {
    var breadCrumbsArray = ACC.repairProducts.setBreadCrumbForProductType();

    ACC.repairProducts.populateWarrrantyInfo();
    ACC.repairProducts.loadBreadCrumbsForProducttype(2, breadCrumbsArray, 'ph-breadCrumbs_warrantypage');

    $('.ph-sendforRepair').on('change', function() {
      if ($(this).attr('id') === 'ph-notfor_repair') {
        $.each(ACC.repairProducts.outofWarrantyProducts, function(item, prod) {
          prod.sendingForRepair = false;
        });
      } else {
        $.each(ACC.repairProducts.outofWarrantyProducts, function(item, prod) {
          prod.sendingForRepair = true;
        });
      }
    });
  },
  populateReviewAndSubmitForSerial: function() {
    if (ACC.repairProducts.activeWarrantyProducts.length > 0) {
      $('.' + ACC.repairProducts.reviewActiveProductContainer).html($('#' + ACC.repairProducts.listItemTemplate).tmpl({
        listItem: ACC.repairProducts.activeWarrantyProducts
      }));

      $('.' + ACC.repairProducts.reviewActiveProdWrapper).show();
    }

    if (ACC.repairProducts.outofWarrantyProducts.length > 0 && $('#' + ACC.repairProducts.phSendingforRepair).prop('checked') === true) {
      $('.' + ACC.repairProducts.reviewOutProductContainer).html($('#' + ACC.repairProducts.listItemTemplate).tmpl({
        listItem: ACC.repairProducts.outofWarrantyProducts
      }));

      $('.' + ACC.repairProducts.reviewOutProdWrapper).show();
    } else {
      $('.' + ACC.repairProducts.reviewOutProdWrapper).hide();
      $('.' + ACC.repairProducts.reviewOutProductContainer).html('');
    }
  },
  populateReviewAndSubmitForNonSerial: function() {
    if (ACC.repairProducts.productInfosDetailedList.length > 0) {
      $('.' + ACC.repairProducts.reviewActiveProductContainer).html($('#repairsListItemNonSerial').tmpl({
        listItem: ACC.repairProducts.productInfosDetailedList
      }));

      $('.' + ACC.repairProducts.reviewActiveProdWrapper).show();
    }
  },
  loadReviewnSubmitInfo: function() {
    var breadCrumbs = ACC.repairProducts.setBreadCrumbForProductType();

    if ($('.' + ACC.repairProducts.isSerializedType).val() === 'true') {
      ACC.repairProducts.loadBreadCrumbsForProducttype(3, breadCrumbs, 'ph-breadCrumbs_reviewpage');
      ACC.repairProducts.populateReviewAndSubmitForSerial();
      $('.' + ACC.repairProducts.phSerialMsgBanner).show();
    } else {
      breadCrumbs = ACC.repairProducts.setBreadCrumbForProductType(breadCrumbs);
      ACC.repairProducts.loadBreadCrumbsForProducttype(2, breadCrumbs, 'ph-breadCrumbs_reviewpage');
      ACC.repairProducts.populateReviewAndSubmitForNonSerial();
      $('.' + ACC.repairProducts.phSerialMsgBanner).hide();
    }

    if (localStorage.getItem(ACC.repairProducts.poNumber)) {
      $('.ph-repairs_ponumber').text(localStorage.getItem(ACC.repairProducts.poNumber));
      $('.ph-review_ponumber').show();
    } else {
      $('.ph-review_ponumber').hide();
    }
  },

  populateFinalForSerial: function() {
    var finalPagwDiv = false;

    if (ACC.repairProducts.activeWarrantyProducts.length > 0) {
      $('.' + ACC.repairProducts.reviewActiveProductContainer).html($('#' + ACC.repairProducts.listItemFinalTemplate).tmpl({
        listItem: ACC.repairProducts.activeWarrantyProducts
      }));

      $('.' + ACC.repairProducts.reviewActiveProdWrapper).show();
    }

    if (ACC.repairProducts.outofWarrantyProducts.length > 0 && $('#' + ACC.repairProducts.phSendingforRepair).prop('checked') === true) {
      $('.' + ACC.repairProducts.reviewOutProductContainer).html($('#' + ACC.repairProducts.listItemFinalTemplate).tmpl({
        listItem: ACC.repairProducts.outofWarrantyProducts
      }));

      $('.' + ACC.repairProducts.reviewOutProdWrapper).show();
    } else {
      $('.' + ACC.repairProducts.reviewOutProdWrapper).hide();
      $('.' + ACC.repairProducts.reviewOutProductContainer).html('');
    }

    if ($('.' + ACC.repairProducts.reviewActiveProdWrapper).css('display') === 'none' && $('.' + ACC.repairProducts.reviewOutProdWrapper).css('display') === 'none') {
      finalPagwDiv = true;
    }

    if (ACC.repairProducts.notServicableProducts.length > 0 && finalPagwDiv) {
      ACC.repairProductsAjax.nonSerialThankyouMessage();
    } else {
      ACC.repairProductsAjax.serialThankyouMessage();
    }

    if ($('.' + ACC.repairProducts.reviewActiveProdWrapper).css('display') === 'none' && $('.' + ACC.repairProducts.reviewOutProdWrapper).css('display') === 'none') {
      ACC.repairProductsAjax.nonSerialThankyouMessage();
    } else {
      ACC.repairProductsAjax.serialThankyouMessage();
    }
  },

  populateFinalForNonSerial: function() {
    if (ACC.repairProducts.productInfosDetailedList.length > 0) {
      $('.' + ACC.repairProducts.reviewActiveProductContainer).html($('#repairsListItemFinalNonSerial').tmpl({
        listItem: ACC.repairProducts.productInfosDetailedList
      }));

      $('.' + ACC.repairProducts.reviewActiveProdWrapper).show();
    }
  },

  displayErrorMessageForSN: function(snArrays) {
    var errorMessage = $('.' + ACC.repairProducts.commonErrorMessage).text();

    $('.' + ACC.repairProducts.serialNumberErrorMsg).html(errorMessage.replace('xxx', snArrays.join()));
    $('.' + ACC.repairProducts.serialNumberErrorBlock).show();
  },
  displayErrorMessageForMaxLimit: function(type) {
    var cpaperrorMessage = $('.ph-maxlimit_cpap_errmsg').text(),
        ventsErrorMessage = $('.ph-maxlimit_vents_errmsg').text(),
        errormsg = '';

    if (type === 'C') {
      errormsg = cpaperrorMessage;
    } else {
      errormsg = ventsErrorMessage;
    }

    $('.' + ACC.repairProducts.serialNumberErrorMsg).html(errormsg);
    $('.' + ACC.repairProducts.serialNumberErrorBlock).show();
  },
  displayErrorMessageForPartNo: function(snArrays) {
    var errorMessage = '';

    if (snArrays === 'P') {
      errorMessage = $('.ph-maxlimit_partnumber_errmsg').text();
      $('.' + ACC.repairProducts.nonSerialNumberErrorMsg).html(errorMessage);
    } else {
      errorMessage = $('.' + ACC.repairProducts.commonErrorMessage).text();
      $('.' + ACC.repairProducts.nonSerialNumberErrorMsg).html(errorMessage.replace('xxx', snArrays.join()));
    }

    $('.' + ACC.repairProducts.nonSerialErrorBlock).show();
  },
  checkSerialNumberLimit: function(serialNumberArrays) {
    var productType = $('#producttype').val(),
        isError = true;

    if (productType === ACC.repairProducts.productTypeCpap && serialNumberArrays.length > 3) {
      ACC.repairProducts.displayErrorMessageForMaxLimit('C');
    } else if (productType !== ACC.repairProducts.productTypeCpap && serialNumberArrays.length > 1) {
      ACC.repairProducts.displayErrorMessageForMaxLimit('V');
    } else {
      isError = false;
    }

    return isError;
  },
  validateSerialNumberInput: function() {
    var $serialNumberInput = $('#prodtype_CPAP .ph-serialNumbersvalue'),
        regex = new RegExp('^[a-zA-Z0-9]{1,18}$'),
        slNoErrorMsg = $('.' + ACC.repairProducts.commonErrorMessage).text(),
        serialNumberArrays = $serialNumberInput.val().split(','),
        errorFlag = '',
        invalidSerialNumbers = '';

    errorFlag = ACC.repairProducts.checkSerialNumberLimit(serialNumberArrays, slNoErrorMsg);

    if (!errorFlag && $serialNumberInput.val().length > 0) {
      invalidSerialNumbers = serialNumberArrays.filter(function(serialNumber) {
        return $.trim(serialNumber).length > 0 && !regex.test($.trim(serialNumber));
      });

      if (invalidSerialNumbers.length > 0) {
        ACC.repairProducts.displayErrorMessageForSN(invalidSerialNumbers);
        errorFlag = true;
      } else {
        $('.' + ACC.repairProducts.serialNumberErrorMsg).html('');
        $('.' + ACC.repairProducts.serialNumberErrorBlock).hide();
      }
    }

    if ($serialNumberInput.val().length === 0) {
      ACC.repairProducts.validateInputFields($serialNumberInput);
    }

    return errorFlag;
  },
  checkPartNumberLimit: function(partNumberArray) {
    var isError = true;

    if (partNumberArray.length > 1) {
      ACC.repairProducts.displayErrorMessageForPartNo('P');
      isError = false;
    }

    return isError;
  },
  validatePartNumber: function($partNumberInput) {
    var regex = new RegExp('^[a-zA-Z0-9]{1,18}$'),
        partNumberArray = '',
        limitNotExceeded = true,
        isError = false;

    if ($partNumberInput.val() === '') {
      ACC.repairProducts.setErrorFlag($partNumberInput, true);
      isError = true;
    } else {
      ACC.repairProducts.clearErrorFlag($partNumberInput, true);
    }

    partNumberArray = $partNumberInput.val().split(',');
    limitNotExceeded = ACC.repairProducts.checkPartNumberLimit(partNumberArray);

    if (limitNotExceeded) {
      if ($partNumberInput.val().length > 0 && !regex.test($partNumberInput.val())) {
        ACC.repairProducts.displayErrorMessageForPartNo($partNumberInput.val().split(','));
        isError = true;
      } else {
        $('.' + ACC.repairProducts.nonSerialNumberErrorMsg).html('');
        $('.' + ACC.repairProducts.nonSerialErrorBlock).hide();
      }
    } else {
      isError = true;
    }

    return isError;
  },
  checkForInvalidSerialNumbers: function(responseMessages, isSerialProduct) {
    var invalidSerialNumbers = '',
        productItem = '',
        desc = 'create_repair_request:product_info:search:failure:';

    if (responseMessages.responseMessagesList !== null) {
      if (responseMessages && responseMessages.responseMessagesList.length > 0) {
        invalidSerialNumbers = responseMessages.responseMessagesList.map(function(item) {
          if (isSerialProduct) {
            productItem = item.serialNumber;
          } else {
            productItem = item.materialNumber;
          }

          return productItem;
        });

        if (isSerialProduct) {
          ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, desc + invalidSerialNumbers.join());
          ACC.repairProducts.displayErrorMessageForSN(invalidSerialNumbers);
        } else {
          ACC.repairProducts.displayErrorMessageForPartNo(invalidSerialNumbers);
        }
      }
    }
  },
  showInputFormElements: function(isSerializedProduct, productType) {
    var flexClass = 'ph-d-flex',
        rddProductType = ACC.repairProducts.productTypeRdd;

    if (String(isSerializedProduct) === 'true') {
      ACC.repairProducts.showCpapLabel(productType);
      $(ACC.repairProducts.nonSerializedStep).removeClass(flexClass).hide();
      $(ACC.repairProducts.serializedStep).addClass(flexClass);
      $(ACC.repairProducts.prodtypeCpapId).show();
      $(ACC.repairProducts.prodtypeMaskId).hide();
      $(ACC.repairProducts.prodtypeRddId).hide();
    } else if (String(isSerializedProduct) === 'false' && productType === rddProductType) {
      $(ACC.repairProducts.nonSerializedStep).addClass(flexClass);
      $(ACC.repairProducts.serializedStep).removeClass(flexClass).hide();
      $(ACC.repairProducts.prodtypeCpapId).hide();
      $(ACC.repairProducts.prodtypeMaskId).hide();
      $(ACC.repairProducts.prodtypeRddId).show();
    } else {
      $(ACC.repairProducts.nonSerializedStep).addClass(flexClass);
      $(ACC.repairProducts.serializedStep).removeClass(flexClass).hide();
      $(ACC.repairProducts.prodtypeCpapId).hide();
      $(ACC.repairProducts.prodtypeMaskId).show();
      $(ACC.repairProducts.prodtypeRddId).hide();
    }
  },
  productTypeOptionIteration: function(items) {
    var optionsHtml = '';

    items.forEach(function(item) {
      optionsHtml = optionsHtml + '<option data-isserialized=\'' + item.isSerializedProduct + '\' value=\'' + item.productName + '\'>' + item.productName + '</option>';
    });

    return optionsHtml;
  },
  clearFormFeilds: function() {
    var $formFeildWrap = $('.ph-form__fieldwrap'),
        formFieldErrorClass = ACC.repairProducts.formFieldErrorClass;

    $('.form_field-input input').val('');
    $formFeildWrap.removeClass(formFieldErrorClass);
    $formFeildWrap.find('.ph-repairs__emptyvalue').text('');
    $('.' + ACC.repairProducts.serialNumberErrorMsg).html('');
    $('#' + ACC.repairProducts.repairsProductList).html('');
    $('.' + ACC.repairProducts.repairProductsContainer).hide('');
    $('.' + ACC.repairProducts.serialNumberErrorBlock).hide();
    $(ACC.repairProducts.prodInfostartButton).addClass(ACC.repairProducts.disabledbuttonClass);
    $('.' + ACC.repairProducts.rddCheckButton).addClass(ACC.repairProducts.disabledbuttonClass);
    $('.' + ACC.repairProducts.maskCheckButton).addClass(ACC.repairProducts.disabledbuttonClass);
    ACC.repairProducts.warrantyInfosDetailedList = '';
    ACC.repairProducts.productInfosDetailedList = [];
    ACC.repairProducts.warrantyDuplicationHybrisList = '';
    $('.' + ACC.repairProducts.nonSerialNumberErrorMsg).html('');
    $('.' + ACC.repairProducts.nonSerialErrorBlock).hide();
  },
  showCpapLabel: function(productType) {
    var cpapSerialNumberlabel = $('.ph-cpap_serialnumber_label').html(),
        ventSerialNumberlabel = $('.ph-vents_serialnumber_label').html();

    if (productType === ACC.repairProducts.productTypeCpap) {
      $('.ph-cpap-label').show();
      $('.ph-serialnumber_inputlabel').html(cpapSerialNumberlabel);
      $('#' + ACC.repairProducts.serialNumberInput).attr('maxlength', '57');
    } else {
      $('.ph-cpap-label').hide();
      $('.ph-serialnumber_inputlabel').html(ventSerialNumberlabel);
      $('#' + ACC.repairProducts.serialNumberInput).attr('maxlength', '18');
    }
  },
  setErrorFlag: function(item) {
    var itemParent = item.closest('.ph-inputData'),
        errorMsgSpan = ACC.repairProducts.errorMsgSpan,
        formFieldErrorClass = ACC.repairProducts.formFieldErrorClass;

    if (itemParent.find('.' + formFieldErrorClass).length === 0) {
      item.closest(ACC.repairProducts.errorSpanClass).addClass(formFieldErrorClass);
      item.closest(ACC.repairProducts.errorSpanClass).find('.' + errorMsgSpan).text(itemParent.attr('data-emptyContent'));
    }
  },
  clearErrorFlag: function(item) {
    var itemParent = item.closest('.ph-inputData'),
        errorMsgSpan = ACC.repairProducts.errorMsgSpan,
        formFieldErrorClass = ACC.repairProducts.formFieldErrorClass;

    if (itemParent.find('.' + formFieldErrorClass).length > 0) {
      item.closest(ACC.repairProducts.errorSpanClass).removeClass(formFieldErrorClass);
      item.closest(ACC.repairProducts.errorSpanClass).find('.' + errorMsgSpan).text('');
    }
  },
  validateInputFields: function($item) {
    if ($item.val() === '') {
      ACC.repairProducts.setErrorFlag($item, true);
    }
  },
  isAddressSelected: function() {
    if (String(localStorage.getItem(ACC.repairProducts.selectedAddrString)) === 'null') {
      $('.ph-repairs_shippingaddr').hide();
    } else {
      $(ACC.repairProducts.leftNavigation).addClass(ACC.repairProducts.hiddenClass);
      $('.ph-btnstartrequest').removeClass(ACC.repairProducts.disabledbuttonClass);
      $('.ph-repairs_shippingaddr').show();
    }
  },
  hideShowLeftNav: function() {
    if (location.hash === '#issues' || location.hash === '#warranty') {
      $(ACC.repairProducts.leftNavigation).hide();
    }
  },
  setPoNumberValue: function() {
    var poNumber = localStorage.getItem(ACC.repairProducts.poNumber);

    if (poNumber) {
      $('#poNumber').val(poNumber);
    }
  },
  clearAllFlags: function() {
    location.hash = '';
    localStorage.removeItem(ACC.repairProducts.poNumber);
    localStorage.removeItem(ACC.repairProducts.fromPageString);
    localStorage.removeItem(ACC.repairProducts.selectedAddrString);
  },
  resetHashTag: function() {
    if (localStorage.getItem(ACC.repairProducts.fromPageString) !== '#createrepair') {
      location.hash = 'createrepair';
      $(ACC.repairProducts.leftNavigation).show();
      $('.' + ACC.repairProducts.repairHistoryContainer).removeClass(ACC.repairProducts.hiddenClass);
      $('.ph-repairs_questionare').prop('checked', false);
    }
  }
};
$(document).ready(function() {
  if ($('.ph-repairreq_container').length > 0) {
    if (location.hash === '') {
      if (localStorage.getItem(ACC.repairProducts.fromPageString) === ACC.repairProducts.hashShippingInfo) {
        location.hash = ACC.repairProducts.hashShippingInfo;
        $('.' + ACC.repairProducts.repairHistoryContainer).addClass(ACC.repairProducts.hiddenClass);
        ACC.repairProducts.setPoNumberValue();
        ACC.repairProducts.isAddressSelected();
      } else {
        location.hash = 'createrepair';
        $(ACC.repairProducts.leftNavigation).show();
        $('.' + ACC.repairProducts.repairHistoryContainer).removeClass(ACC.repairProducts.hiddenClass);
      }
    } else {
      ACC.repairProducts.resetHashTag();
    }

    if (location.hash === '#productinfo') {
      $(ACC.repairProducts.leftNavigation).hide();
      $('.' + ACC.repairProducts.repairHistoryContainer).addClass(ACC.repairProducts.hiddenClass);
      ACC.repairProductsAjax.populateProductTypeDropdown();
    }

    ACC.repairProducts.hideShowLeftNav();

    $(document).on('click', '.ph-header_b2bunitname-selectBox-dropdown-menu li', function() {
      $(ACC.repairProducts.leftNavigation).show();
      ACC.repairProducts.clearAllFlags();
    });

    $(window).on('hashchange', function() {
      if (location.hash === '#createrepair') {
        $(ACC.repairProducts.leftNavigation).show();
        $('.' + ACC.repairProducts.repairHistoryContainer).removeClass(ACC.repairProducts.hiddenClass);
      } else {
        $(ACC.repairProducts.leftNavigation).hide();
        $('.' + ACC.repairProducts.repairHistoryContainer).addClass(ACC.repairProducts.hiddenClass);
      }
    });
  }

  ACC.repairProducts.bindAll();

  $('#lotNumber2').on('blur', function() {
    ACC.repairProducts.maskFieldsValidation();
  });
});

